export function debounce<A = unknown, R = void>(
  function_: (arguments_: A) => R,
  ms: number,
): (arguments_: A) => Promise<R> {
  let timer: ReturnType<typeof setTimeout>;

  return (arguments_: A): Promise<R> =>
    new Promise((resolve) => {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        resolve(function_(arguments_));
      }, ms);
    });
}
